// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___3lsbn","container_1":"container_1___3G61G","container_2":"container_2___1kqOt"};


//////////////////
// WEBPACK FOOTER
// ./src/views/HotKeywords/styles.module.scss
// module id = 1701
// module chunks = 0